import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import fetchData from '@/util/fetch'

// What energize stores of a meter's SolarEdge site (/meters/{serial}/solaredge?live=none: site, inverters,
// open alerts). Free, so it loads with the page; the summary and the details modal share it.
export function useSolarEdgeStatus(serialNumber) {
  return useQuery({
    queryKey: computed(() => ['meterSolarEdge', serialNumber.value]),
    queryFn: async () => {
      const result = await fetchData(`/eleena/api/v1/meters/${serialNumber.value}/solaredge?live=none`)
      return result?.data ?? null
    },
    enabled: computed(() => !!serialNumber.value),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
}

// SolarEdge mixes W and kW in peakPower (3500.0 vs 3.5)
export const formatPeakPower = (kw) => {
  if (kw == null) return '—'
  return kw > 100 ? `${(kw / 1000).toLocaleString('nl-NL')} kWp` : `${kw.toLocaleString('nl-NL')} kWp`
}
